import { render, staticRenderFns } from "./trainingInstitutionCourseList.vue?vue&type=template&id=dce4194c&scoped=true&"
import script from "./trainingInstitutionCourseList.vue?vue&type=script&lang=js&"
export * from "./trainingInstitutionCourseList.vue?vue&type=script&lang=js&"
import style0 from "./trainingInstitutionCourseList.vue?vue&type=style&index=0&id=dce4194c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce4194c",
  null
  
)

export default component.exports